import { render, staticRenderFns } from "./RecruitStudent.vue?vue&type=template&id=6aea6d27&scoped=true&"
import script from "./RecruitStudent.vue?vue&type=script&lang=js&"
export * from "./RecruitStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea6d27",
  null
  
)

export default component.exports